import {
    BimCalculateInflationEnum,
    ContractStatusEnum,
    type BimActKc2TotalItemData,
    WorkOrderStatusEnum,
    ProjectStatusEnum,
} from 'gql/graphql';
import { Switch, Radio, cnMixSpace } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';

import type { IActTotalDetailsProps } from '../types';

export const ActTotalDetailsNameCell = (
    props: ICellRendererParams<BimActKc2TotalItemData & { inflationCalcType?: BimCalculateInflationEnum }> &
        Omit<IActTotalDetailsProps, 'resetCalculatedHandler' | 'setInputValueHandler'>,
) => {
    const {
        value = '',
        data,
        updateLimitedHandler,
        actKC2Id,
        contractStatus,
        workOrderStatus,
        setTotalInflationHandler,
        statusProject,
        isVersion,
        isActionDisabled,
        isReadOnly,
        inflationCalcType,
    } = props;

    const isContractStatusDelayed = contractStatus === ContractStatusEnum.Delayed;
    const isContractStatusCompleted = contractStatus === ContractStatusEnum.Completed;

    const isWorkOrderStatusDelayed = workOrderStatus === WorkOrderStatusEnum.Delayed;
    const isWorkOrderStatusCompleted = workOrderStatus === WorkOrderStatusEnum.Completed;

    const isProjectStatusDelayed = statusProject === ProjectStatusEnum.Delayed;

    const actionsDisabled =
        isContractStatusDelayed ||
        isContractStatusCompleted ||
        isWorkOrderStatusDelayed ||
        isWorkOrderStatusCompleted ||
        isProjectStatusDelayed ||
        isVersion ||
        isActionDisabled;

    if (isReadOnly) {
        return value;
    }

    if (data?.limitedCostType) {
        const isChecked = data?.isSelected;

        const onChangeHandler = ({ checked }: { checked: boolean }) => {
            if (data?.limitedCostType) {
                updateLimitedHandler({
                    actKC2Id,
                    limitedItems: [data?.limitedCostType],
                    useLimited: checked,
                });
            }
        };

        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Switch
                    checked={isChecked}
                    onChange={onChangeHandler}
                    size="s"
                    className={cnMixSpace({ mR: 'xs' })}
                    disabled={actionsDisabled}
                />
                {value}
            </div>
        );
    }

    if (data?.isInflation) {
        const onRadioChange = () => {
            if (data?.workOrderSeasonId) {
                setTotalInflationHandler({
                    actKC2Id,
                    workOrderSeasonId: data?.workOrderSeasonId,
                });
            }
        };

        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {inflationCalcType !== BimCalculateInflationEnum.DefinedInPrice && (
                    <Radio
                        checked={Boolean(
                            data?.workOrderActiveSeasonId && data?.workOrderActiveSeasonId === data?.workOrderSeasonId,
                        )}
                        size="m"
                        className={cnMixSpace({ mR: 'xs' })}
                        disabled={actionsDisabled}
                        onChange={onRadioChange}
                    />
                )}
                {value}
            </div>
        );
    }

    return value;
};

ActTotalDetailsNameCell.displayName = 'ActTotalDetailsNameCell';
